// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"749185d4b3b657742550","351":"0e4c2d5610f957e734fd","691":"a770d314bf6019df790d","954":"cede2350f65661d1e0c9"}[chunkId] + ".js";
};